import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { BsFormControl, BsFormSelect, BsModalForm } from '../../collection/bootstrap/BootstrapComponents';
import Loading from '../../collection/icons/Loading';
import { apiForm, apiGet } from '../../utils/api';
import { notify } from '../../utils/notifications';
import { useLoad } from '../../collection/Hooks';
import { localDateTime } from '../../utils/functions';

export default function Fichaje(props) {
    const [last, reload] = useLoad(async () => await apiGet("fichajes/getLast"));
    const isNew = props.isNew || props.idFichaje < 1;

    const updateData = async () => await apiGet("fichajes/get/" + props.idFichaje);

    const checkData = formData => {
        let errors = {};
        if (isNew && props.super) {
            // Fecha y hora
            const fecha = formData.get("fecha");
            const hora = formData.get("hora");
            if (!fecha) {
                errors["fecha"] = "Campo obligatorio";
            }
            if (!hora) {
                errors["hora"] = "Campo obligatorio";
            }
            if (fecha && hora) {
                let fh = moment(fecha + ' ' + hora);
                if (!fh.isValid()) {
                    errors["hora"] = "Fecha y hora no válidas";
                }
                else {
                    formData.append("fechaHora", fh.format());
                }
            }
            // Trabajador
            const trabajador = formData.get("trabajador");
            if (!trabajador) {
                errors["trabajador"] = "Campo obligatorio";
            }
        }
        return errors;
    }

    const saveData = async data => {
        const action = isNew ? (props.super ? "new" : "fichar") : "edit";
        const result = await apiForm("fichajes/" + action, data);
        if (result) {
            props.onHide();
            if (props.notifyOk)
                notify("Fichaje guardado correctamente", 'success');
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? (props.super ? "Nuevo Fichaje" : (last ? `Último fichaje: ${localDateTime(last.fechaHora, 'dddd HH:mm (D/M/YY)')}` : "Fichar")) : "Editar comentario"}
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            <FichajeForm
                super={props.super}
                admin={props.admin}
                defaultTrabajador={props.defaultTrabajador}
                defaultFecha={props.defaultFecha}
            />
        </BsModalForm>
    );
}

function FichajeForm(props) {
    // api data
    const isSuper = props.isNew && props.super;
    const [listTrabajadores, setListTrabajadores] = useState();
    useEffect(() => {
        const updateListTrabajadores = async () => {
            setListTrabajadores(await apiGet(`usuarios/list${props.admin ? "" : "trabajadores"}`));
        };
        if (isSuper) {
            updateListTrabajadores();
        }
    }, [props]);

    // default values
    const fecha = props.defaultFecha ? props.defaultFecha : props.data.fecha;
    const trabajador = props.defaultTrabajador ? props.defaultTrabajador : props.data.trabajador;

    // render
    return (isSuper && !listTrabajadores) ? <Loading /> : <>
        {isSuper && <>
            <BsFormControl
                /* Fecha */
                label="Fecha" name="fecha"
                value={fecha} error={props.errors.fecha}
                type="date" />
            <BsFormControl
                /* Hora */
                label="Hora" name="hora"
                value={props.data.hora} error={props.errors.hora}
                className="mt-3" type="time" />
            <BsFormSelect
                /* Trabajador */
                label="Trabajador" name="trabajador"
                value={trabajador} error={props.errors.trabajador}
                options={listTrabajadores}
                className="my-3" />
        </>}

        { /* Dieta */}
        <Row
            className="mt-3">
            <Col sm={4}>Dieta</Col>
            <Col sm={8}>
                <Form.Check
                    name="dieta" value="true"
                    defaultChecked={props.data.dieta}
                    type="switch" id="dieta" />
            </Col>
        </Row>

        <BsFormControl
            /* Comentario */
            label="Comentario" name="comentario"
            value={props.data.comentario} error={props.errors.comentario}
            maxLength="250" as="textarea" className="mt-3" />
    </>;
}
